import React, { useState } from "react";
import { Box, Button, IconButton, Menu, Tooltip } from "@mui/material";
import {
  FaBold,
  FaStrikethrough,
  FaCode,
  FaItalic,
  FaSmile,
  FaPlus,
} from "react-icons/fa";
import Picker from "@emoji-mart/react";
import emojiData from "@emoji-mart/data";
import { GlassButton } from "../themes/UiElements";
import {
  MdAdd,
  MdBolt,
  MdCode,
  MdEmojiEmotions,
  MdFormatBold,
  MdFormatItalic,
  MdOutlinePlusOne,
  MdStrikethroughS,
} from "react-icons/md";

const TextToolsPanel = ({
  variableRequired = false,
  cIndex = 0,
  disableVar = false,
  disablePanel = false,
  onInsertChar,
  conProps = {},
}) => {
  const [emojiAnchorEl, setEmojiAnchorEl] = useState(null);

  const handleEmojiSelect = (em) => {
    onInsertChar(em, 2);
    setEmojiAnchorEl(null);
  };

  const handleClick = (action, event) => {
    switch (action) {
      case "bold":
        onInsertChar("**", 1);
        break;
      case "strikethrough":
        onInsertChar("~~", 1);
        break;
      case "monospace":
        onInsertChar("````", 2);
        break;
      case "italic":
        onInsertChar("__", 1);
        break;
      case "emoji":
        setEmojiAnchorEl(event.currentTarget);
        break;
      case "variable":
        onInsertChar(`{{${cIndex}}}`, 4 + `${cIndex}`.length);
        break;
      default:
        console.log("Unknown action");
    }
  };

  return (
    <Box display="flex" justifyContent="flex-end" gap={1} {...conProps}>
      <Tooltip title="Bold">
        <IconButton
          size="small"
          disabled={disablePanel}
          onClick={(e) => handleClick("bold", e)}
        >
          <MdFormatBold />
        </IconButton>
      </Tooltip>
      <Tooltip title="Strikethrough">
        <IconButton
          size="small"
          disabled={disablePanel}
          onClick={(e) => handleClick("strikethrough", e)}
        >
          <MdStrikethroughS />
        </IconButton>
      </Tooltip>
      <Tooltip title="Monospace">
        <IconButton
          size="small"
          disabled={disablePanel}
          onClick={(e) => handleClick("monospace", e)}
        >
          <MdCode />
        </IconButton>
      </Tooltip>
      <Tooltip title="Italic">
        <IconButton
          size="small"
          disabled={disablePanel}
          onClick={(e) => handleClick("italic", e)}
        >
          <MdFormatItalic />
        </IconButton>
      </Tooltip>
      <Tooltip title="Insert Emoji">
        <IconButton
          size="small"
          disabled={disablePanel}
          onClick={(e) => handleClick("emoji", e)}
        >
          <MdEmojiEmotions />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={emojiAnchorEl}
        open={Boolean(emojiAnchorEl)}
        onClose={() => setEmojiAnchorEl(null)}
      >
        <Picker
          data={emojiData}
          onEmojiSelect={(emoji) => handleEmojiSelect(emoji.native)}
          maxFrequentRows={0}
          perLine={8}
          skinTonePosition="search"
          theme="auto"
          previewPosition="none"
        />
      </Menu>
      {variableRequired && (
        <Tooltip title="Add Variable">
          <GlassButton
            size="small"
            variant="outlined"
            startIcon={<MdAdd />}
            disabled={disablePanel || disableVar}
            onClick={(e) => handleClick("variable", e)}
          >
            Variable
          </GlassButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default TextToolsPanel;
